import { lazy, Suspense } from 'react'

import { useLocation, Route, Routes } from 'react-router-dom'

import { useSettings } from '@loadsmart/react-frontend-settings'

import FIAIRedirect from 'auth/ui/FIAIRedirect'
import LoginPage from 'auth/ui/LoginPage'
import LoginThroughBIP from 'auth/ui/LoginThroughBIP'
import LoginThroughBIPCallback from 'auth/ui/LoginThroughBIPCallback'
import OpenDockLoginPage from 'auth/ui/OpenDockLoginPage'
import LogoutPage from 'auth/ui/LogoutPage'
import HomePage from 'home/ui/HomePage'
import AnalyticsLibraryPage from 'managed-analytics/ui/AnalyticsLibraryPage'
import AnalyticsMcpPage from 'managed-analytics/ui/AnalyticsMcpPage'
import DemoIntegrationsPage from 'managed-analytics/ui/DemoIntegrationsPage'
import DemoPerformanceReportsPage from 'managed-analytics/ui/DemoPerformanceReportsPage'
import DemoReportPage from 'managed-analytics/ui/DemoReportPage'
import DemoSchedulePage from 'managed-analytics/ui/DemoSchedulePage'
import IntegrationsPage from 'managed-analytics/ui/IntegrationsPage'
import ManagedAnalyticsPage from 'managed-analytics/ui/ManagedAnalyticsPage'
import PerformanceReportsPage from 'managed-analytics/ui/PerformanceReportsPage'
import ReportPage from 'managed-analytics/ui/ReportPage'
import SchedulePage from 'managed-analytics/ui/SchedulePage'

import MobileNotSupported from './components/mobile/MobileNotSupported'
import PrivatePage from './components/PrivatePage'

// Its own chunk: the chat and @loadsmart/ai-chat download only when someone opens
// /assistant, and the only link there shows only while ENABLE_AI_CHAT is on.
const AssistantPage = lazy(() => import('assistant/ui/AssistantPage'))

const Router = () => {
  const location = useLocation()
  const { isLoading, values } = useSettings([
    'flags.ENABLE_LOGIN_THROUGH_BIP',
    'flags.ENABLE_LOGIN_THROUGH_OPENDOCK',
  ])

  const [isLoginThroughBIPEnabled, isOpenDockLoginEnabled] = values

  console.log('[Router] Raw feature flags received:', {
    isLoading,
    rawValues: values,
    rawValuesType: typeof values,
    rawBIPFlag: isLoginThroughBIPEnabled,
    rawBIPFlagType: typeof isLoginThroughBIPEnabled,
    rawOpenDockFlag: isOpenDockLoginEnabled,
    rawOpenDockFlagType: typeof isOpenDockLoginEnabled,
  })

  const isBIPEnabled = Boolean(isLoginThroughBIPEnabled)
  const isOpenDockEnabled = Boolean(isOpenDockLoginEnabled)

  return isLoading ? null : (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {isBIPEnabled ? (
        <>
          <Route path="/login" element={<LoginThroughBIP />} />
          <Route path="/login-callback" element={<LoginThroughBIPCallback />} />
        </>
      ) : (
        <Route path="/login" element={<LoginPage />} />
      )}
      <Route path="/login-lmt" element={<LoginPage />} />
      {isOpenDockEnabled && <Route path="/login-opendock" element={<OpenDockLoginPage />} />}
      <Route path="/logout" element={<LogoutPage />} />

      <Route element={<PrivatePage />}>
        <Route path="/analytics" element={<ManagedAnalyticsPage key={location.key} />} />
        <Route path="/integrations" element={<IntegrationsPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
        <Route path="/performance-reports" element={<PerformanceReportsPage />} />
        <Route path="/reports/:reportId" element={<ReportPage />} />
      </Route>
      <Route path="/demo" element={<AnalyticsLibraryPage />} />
      <Route path="/demo/performance-reports" element={<DemoPerformanceReportsPage />} />
      <Route path="/demo/integrations" element={<DemoIntegrationsPage />} />
      <Route path="/demo/schedule" element={<DemoSchedulePage />} />
      <Route path="/demo-reports/:reportId" element={<DemoReportPage />} />
      <Route path="/analytics-mcp" element={<AnalyticsMcpPage />} />
      <Route
        path="/assistant"
        element={
          <Suspense fallback={null}>
            <AssistantPage />
          </Suspense>
        }
      />
      <Route
        path="/assistant/:threadId"
        element={
          <Suspense fallback={null}>
            <AssistantPage />
          </Suspense>
        }
      />

      <Route path="/mobile-not-supported" element={<MobileNotSupported />} />
      <Route path="/fiai_redirect" element={<FIAIRedirect />} />
    </Routes>
  )
}

export default Router
